import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_wrkrs_exposed_to_hazardous_substances_in_the_production_pro'

export const dataPointDefinition = {
  retracedId: 'are_wrkrs_exposed_to_hazardous_substances_in_the_production_pro',
  name: 'Are workers exposed to hazardous substances in the production process/ in the course of their work?',
  description:
    "Production process means operations/activities related to the production of goods (including maintenance of machinery for the production of goods) and/or the workers' operations. Activities related to toilet maintenance and canteen, e.g., are not related to the production process. \r\r\n\r\r\nHazardous substances mean chemicals that affect reproduction or cause birth defects, or if they are cancer-causing, irritants, allergenic, toxic, flammable, explosive, oxidizing, dangerously reactive, or corrosive.\r\r\n\r\r\nExamples of hazardous substances in apparel and footwear: potassium permanganate (for denim finishing), DMF-solvent (for fake leather production), tetrachloroethylene (PERC) (for dry cleaning).",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-che-11',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15180,
  sectionId: '2.2.9.5',
  impactArea: 'Chemicals and Hazardous Substances',
  impactAreaId: 'CHEMICALS_AND_HAZARDOUS_SUBSTANCES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
